export enum WeekendDaysEnum {
    'SUNDAY'= 0,
    'SATURDAY' = 6
}
